export enum MStoreOrderableTableDirection {
  Up = 1,
  Down = 2
}
